import { render, staticRenderFns } from "./WebRequiresUserFlag.vue?vue&type=template&id=3437e1c1&scoped=true&"
import script from "./WebRequiresUserFlag.vue?vue&type=script&lang=js&"
export * from "./WebRequiresUserFlag.vue?vue&type=script&lang=js&"
import style0 from "./WebRequiresUserFlag.vue?vue&type=style&index=0&id=3437e1c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3437e1c1",
  null
  
)

export default component.exports